module.exports = __webpack_public_path__ + "static/media/New-Zumama.a89a63cc.svg";